import { Component, Input } from '@angular/core';
import { LpDecisionResult } from 'src/app/models/lp-evaluation/LpEvaluationResult';

@Component({
    selector: 'lp-evaluation-display',
    templateUrl: './lp-evaluation-display.component.html',
    styleUrls: ['./lp-evaluation-display.component.css']
})
export class LpEvaluationDisplayComponent {

    @Input() result: LpDecisionResult | null | undefined = null;

    get legendClass(): string {
        switch (this.result?.decisionType) {
            case 'Agree':              return 'bg-success text-white';
            case 'Clarify':            return 'bg-warning text-dark';
            case 'RecommendDifferent': return 'lp-legend-recommend text-white';
        }
        return 'bg-secondary text-white';
    }

    get badgeLabel(): string {
        switch (this.result?.decisionType) {
            case 'Agree':              return '✓ approved as requested';
            case 'Clarify':            return '⚠ clarification needed';
            case 'RecommendDifferent': return '↕ different permissions suggested';
        }
        return '';
    }
}
